export type FontFamily = 'Ember Modern Text' | 'Amazon Ember' | 'Amazon Ember Display';

/**
 * Maps a selectable font family to its full CSS font stack. Every stack shares
 * the same fallback list defined in src/styles/_typography.scss so switching
 * families never changes the fallback metrics. This is the single source used
 * by both the pre-paint bootstrap (src/index.tsx) and useUserPreferences so the
 * `--font-family-base` value stays consistent everywhere.
 */
export const FONT_FAMILY_STACKS: Record<FontFamily, string> = {
  'Ember Modern Text': "'Ember Modern Text', 'Helvetica Neue', Roboto, Arial, sans-serif",
  'Amazon Ember': "'Amazon Ember', 'Helvetica Neue', Roboto, Arial, sans-serif",
  'Amazon Ember Display': "'Amazon Ember Display', 'Helvetica Neue', Roboto, Arial, sans-serif"
};

export interface HomepageCardVisibility {
  weather: boolean;
  stock: boolean;
  fxRates: boolean;
  newsTicker: boolean;
  nflScores: boolean;
}

export interface UserPreferences {
  fontFamily: FontFamily;
  cardVisibility: HomepageCardVisibility;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  fontFamily: 'Ember Modern Text',
  cardVisibility: {
    weather: true,
    stock: true,
    fxRates: true,
    newsTicker: true,
    nflScores: true
  }
};

/**
 * Resolves a (possibly missing/invalid) font family to its CSS stack, falling
 * back to the app default. Used by the pre-paint bootstrap and the hook.
 */
export const resolveFontStack = (fontFamily: FontFamily | undefined): string =>
  FONT_FAMILY_STACKS[fontFamily as FontFamily] ?? FONT_FAMILY_STACKS[DEFAULT_PREFERENCES.fontFamily];

export type PreferencesSection = 'appearance' | 'language' | 'homepage-cards';
